<template>
    <svg v-if="open" @click="open=!open"
         :class="'text-' + link_color"
         class="w-5 h-5 mt-0.5 text-opacity-100"
         xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24"
         stroke-width="2" stroke="currentColor" fill="none"
         stroke-linecap="round"
         stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="12" cy="12" r="9"></circle>
        <line x1="9" y1="12" x2="15" y2="12"></line>
    </svg>

    <svg v-if="!open" @click="open=!open"
         :class="'group-hover:text-' + link_color"
         class="w-5 h-5 opacity-60 mt-0.5 group-hover:opacity-100"
         xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
         stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
        <circle cx="12" cy="12" r="9"></circle>
        <line x1="9" y1="12" x2="15" y2="12"></line>
        <line x1="12" y1="9" x2="12" y2="15"></line>
    </svg>

    <div class="flex-1 space-y-4">
        <h5 @click="open=!open"
            :class="open ? 'text-' + link_color + ' ' + 'group-hover:text-' + link_color : 'group-hover:text-' + link_color"
            class="text-opacity-100 hover:underline">
            {{ question }}</h5>
        <div v-if="open">
            <textarea
                class="block py-2 px-3 w-full text-sm rounded border-gray-300 transition-shadow focus:ring-0 focus:border-gray-400">{{ answer }}</textarea>
            <btn size="small" :type="button_color" class="mt-3" v-on:click.prevent="copy">Copy to clipboard</btn>
        </div>
    </div>
</template>
<script>
export default {
    props: ['question', 'answer', 'open', 'link_color', 'button_color'],
    methods: {
        copy: function () {
            const el = document.createElement('textarea');
            el.value = this.answer;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
    }
}
</script>
